import dayjs from 'dayjs';
import Text from '../../../components/detail/components/Text.component';
import _ from 'lodash';
import { CommonDetailConf } from '../../yachts/conf/Detail.conf';
import { Chip, Grid, Stack, Box } from '@mui/material';
import Link from '../../../components/detail/components/Link.component';
import LinkPermission from '../../../components/detail/components/LinkPermission.component';
import YachtInvoicingDetails from '../../../components/mexal/YachtInvoicingDetails.component';

export const DetailConf = {
  initialState: {
    loading: false,
    error: null,
    data: null,
    meta: null,
  },
  fields: [
    {
      ...CommonDetailConf,
      items: [
        {
          type: 'text',
          label: 'Yacht name',
          key: 'attributes.yacht',
          xs: 12,
        },
        {
          type: 'link',
          label: 'Web',
          key: 'attributes.url_web',
          xs: 12,
        },
        ...CommonDetailConf.items.map(
          (item) =>
            item.key !== 'attributes.yacht_name' && {
              ...item,
              key: `attributes.id_yacht.data.${item.key}`,
            }
        ),
      ],
    },
    {
      id: 'na_agent',
      type: 'section',
      label: 'NA Agent',
      items: [
        {
          type: 'text',
          label: '',
          key: 'attributes.id_agent_NA.data.attributes.id_users_permissions_user.data',
          xs: 12,
        },
      ],
    },

    {
      id: 'sales_agent',
      type: 'section',
      label: 'Sales Agent',
      items: [
        {
          type: 'text',
          label: '',
          key: 'attributes.id_user_provision.data.attributes.id_users_permissions_user.data',
          xs: 12,
        },
      ],
    },

    {
      id: 'user_tech',
      type: 'section',
      label: 'User Tech',
      items: [
        {
          type: 'text',
          label: '',
          key: 'attributes.id_user_tech.data.attributes.id_users_permissions_user.data',
          xs: 12,
        },
      ],
    },

    {
      id: 'id_teams',
      type: 'section',
      label: 'Teams',
      items: [
        {
          type: 'text',
          label: '',
          key: 'attributes.id_teams',
          xs: 12,
        },
      ],
    },
    {
      id: 'attendance',
      type: 'section',
      label: 'Attendance',
      items: [
        {
          type: 'boolean',
          label: 'Mexal validation',
          key: 'attributes.mexal_validation',
          xs: 12,
          sm: 6,
          md: 4,
          lg: 3,
        },
        {
          type: 'text',
          label: 'Mexal Validation Date',
          key: 'attributes.registration_date',
          xs: 12,
          sm: 6,
          md: 4,
          lg: 3,
        },
        {
          type: 'text',
          label: 'Mexal Research Name',
          key: 'attributes.mexal_research_name',
          xs: 12,
          sm: 6,
          md: 4,
          lg: 3,
        },
        {
          type: 'boolean',
          label: 'Central agent',
          key: 'attributes.is_central_agent',
          xs: 12,
          sm: 6,
          md: 4,
          lg: 3,
        },
        {
          type: 'text',
          label: 'Note',
          key: 'attributes.note',
          xs: 12,
        },
      ],
    },
    {
      id: 'mexal_details',
      type: 'section',
      disableWrapper: true,
      label: '',
      items: [
        {
          type: 'text',
          label: '',
          key: 'attributes.mexal_code',
          xs: 12,
        },
      ],
    },
    {
      id: 'procedures',
      type: 'section',
      label: 'Procedures',
      items: [
        {
          type: 'text',
          label: 'Formalities',
          key: 'attributes.formalities',
          xs: 12,
          sm: 6,
          md: 4,
        },
        {
          type: 'text',
          label: 'ISPS',
          key: 'attributes.isps',
          xs: 12,
          sm: 6,
          md: 4,
        },
        {
          type: 'text',
          label: 'Garbage',
          key: 'attributes.garbage',
          xs: 12,
          sm: 6,
          md: 4,
        },
      ],
    },
    {
      id: 'id_provenence_list',
      type: 'section',
      label: 'Provenance',
      items: [
        {
          type: 'text',
          label: 'Category',
          key: 'attributes.id_provenence_list.data.attributes.provenence_group.data.attributes.group',
          xs: 12,
          sm: 6,
          md: 4,
        },
        {
          type: 'text',
          label: 'Sales channel',
          key: 'attributes.id_provenence_list.data.attributes.provenence_sales_channel.data.attributes.sales_channel',
          xs: 12,
          sm: 6,
          md: 4,
        },
        {
          type: 'text',
          label: 'Provenance',
          key: 'attributes.id_provenence_list.data.attributes.provenence.data.attributes.provenence',
          xs: 12,
          sm: 6,
          md: 4,
        },
        {
          type: 'text',
          label: '',
          key: 'attributes.id_provenence_list.data.attributes',
          xs: 12,
        },
        {
          type: 'text',
          label: 'Note',
          key: 'attributes.id_provenence_list.data.attributes.note',
          xs: 12,
          sm: 6,
          md: 4,
        },
      ],
    },
  ],
  formatValue: (key, value) => {
    switch (key) {
      case 'attributes.yacht':
        return (
          <Grid container>
            <Grid item xs={12} sm={6} md={3}>
              <Stack direction={'row'} spacing={1}>
                <Text
                  label='Yacht name'
                  value={
                    <LinkPermission
                      to={`/yachts/${value?.id}`}
                      value={value?.yacht_name}
                      page='YACHTS'
                    />
                  }
                />
                <Chip label={`#${value?.id || '-'}`} size='small' />
              </Stack>
            </Grid>
            {value?.url_web && (
              <Grid item xs={12} sm={6} md={3}>
                <Link label='Web' value={value?.url_web} />
              </Grid>
            )}
          </Grid>
        );

      case 'attributes.registration_date':
        return (
          <Text
            label='Mexal Validation Date'
            value={dayjs(value).format('DD-MM-YYYY')}
          />
        );

      case 'attributes.mexal_code':
        return (
          <YachtInvoicingDetails
            value={{ mexal_codice: value }}
            showInvoicingDetails={false}
          />
        );

      case 'attributes.id_yacht.data.attributes.draft':
        return (
          <Text label='Draft' value={_.isEmpty(value) ? `${value} m` : '-'} />
        );

      case 'attributes.id_yacht.data.attributes.loa':
        return (
          <Text label='Loa' value={_.isEmpty(value) ? `${value} m` : '-'} />
        );

      case 'attributes.id_yacht.data.attributes.beam':
        return (
          <Text label='Beam' value={_.isEmpty(value) ? `${value} m` : '-'} />
        );

      case 'attributes.id_user_tech.data.attributes.id_users_permissions_user.data':
      case 'attributes.id_user_provision.data.attributes.id_users_permissions_user.data':
      case 'attributes.id_agent_NA.data.attributes.id_users_permissions_user.data':
        return (
          <Text
            label='Name'
            value={
              <LinkPermission
                to={`/na/${value?.id}`}
                value={`${value?.attributes?.name} ${value?.attributes?.surname}`}
                page='CONTACTS_NAUTICA'
              />
            }
          />
        );

      case 'attributes.id_provenence_list.data.attributes':
        const user = !_.isEmpty(value.users_nauticas.data)
          ? value.users_nauticas.data?.attributes?.id_users_permissions_user
            ?.data?.attributes
          : null;

        return (
          <Grid container>
            <Grid item xs={12} sm={6} md={4}>
              <Text label='First Contact' value={value.first_contact} />
            </Grid>
            {value.first_contact === 'USER' && (
              <Grid item xs={12} sm={6}>
                <Text
                  label='User'
                  value={user ? `${user?.name} ${user?.surname}` : '-'}
                />
              </Grid>
            )}
          </Grid>
        );
      case 'attributes.id_teams':
        const data = Array.isArray(value?.data) ? value.data : [];

        return data.length === 0 ? (
          <Box sx={{ flex: 1, minWidth: 0 }}>
            -
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, flex: 1, minWidth: 0 }}>
            {data.map((item, index) => (
              <Chip
                key={item?.id || index}
                label={item?.attributes?.name || item?.name}
                size="small"
                sx={{ height: 24, margin: '2px 0' }}
              />
            ))}
          </Box>
        );

      default:
        return null;
    }
  },
};
